import { find, map, groupBy, kebabCase } from 'lodash'

export default {
  props: {
    provider_id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      provider: {}
    }
  },
  mounted () {
    this.findProvider()
  },
  computed: {
    countries_id() {
      return map(this.provider.players, 'country_iso_3')
    },
    playerTitle() {
      return map(this.provider.players, 'title')
    },
    allProviders() {
      return this.$store.state.players.providers
    },
    listRegions() {

      let players = map(this.provider.players, p => {
        p.url = kebabCase(p.short_name)
        return p
      })

      let regions = map(groupBy(players, 'region_id'), (item, region_id) => {
        return {
          value: region_id,
          text: `${this.translateRegion(region_id)} (${item.length})`,
          players: item
        }
      })

      regions.unshift({ value: 'all', text: this.$t('global.all') })

      return regions
    }
  },
  watch: {
    provider_id () {
      this.findProvider()
    }
  },
  methods: {
    kebabCase,
    findProvider() {
      let provider = find(this.$store.state.players.providers, ['provider_id', this.provider_id])
      this.$set(this, 'provider', provider)
    }
  }
}
